<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Ref } from '@/helpers/Decorators';
import { $t } from '@/plugins/localization';
import { Form } from '@/helpers/Form';
import MSzafirService, { InitSignatureResponse } from '@/modules/logito/signatures/services/mSzafirService';
import { FrontActionModal } from '@/components/common/dynamic-grid/helpers/GridEnums';
import IdeoModal from '@/components/ideo/modal/IdeoModal.vue';
import AddAttachments from '@/views/partials/components/attachments/AddAttachments.vue';
import { BpmnEmitOptions } from '@/modules/low-code/process/services/BpmnService';
import Cookies from 'js-cookie';

@Options({
    components: { AddAttachments },
})
export default class BPMNSignDocumentMSzafirModal extends Vue
{
    @Ref('modal') public modal: () => IdeoModal;
    @Ref('signForm') public signForm: () => HTMLFormElement;

    public action = Form.create<BpmnEmitOptions>({
        id: '',
        licence: '',
        actionName: '',
        buttonId: '',
        displayMode: 'Modal',
        displaySize: 'Medium',
        title: $t('[[[Akceptuj]]]'),
        buttonName: $t('[[[Akceptuj]]]'),
        buttonVariant: 'success',
        buttonIcon: '',
        groupAction: false,
    });

    public initSignatureResponse: InitSignatureResponse = {
        signingId: '',
        status: '',
        statusCode: 0,
        fileIds: [],
        loginHAuth: '',
        loginToken: '',
        loginUrl: ''
    };

    public async mounted(): Promise<void>
    {
        this.$events.$on(FrontActionModal.SignDocumentMSzafir, (action: BpmnEmitOptions) =>
        {
            this.action.withData(action);
            this.modal().show();
        });
    }

    public unmounted(): void
    {
        this.$events.$off(FrontActionModal.SignDocumentMSzafir);
    }

    public async submit(): Promise<void>
    {
        try
        {
            const response = await MSzafirService.initSignature(this.action.licence, this.action.id, this.action.buttonId);

            this.initSignatureResponse = response;

            Cookies.set('docRedirectUrl', this.$route.fullPath);

            await this.$nextTick();

            this.signForm().submit();
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message),
                422: (ex: any) => [
                    this.$alert.warning(Object.values(ex.data.errors).join('\n')),
                ],
            });
        }
    }
}
</script>

<template>
    <IdeoModal ref="modal" :title="action.title" centered>
        <template #default>
            <div class="h6">
                {{ $t('[[[Aby podpisać dokument zaloguj się do usługi mSzafir klikając przycisk poniżej.]]]') }}
            </div>
            <form v-show="false" ref="signForm" :action="initSignatureResponse.loginUrl" method="post" enctype="application/x-www-form-urlencoded">
                <input type="text" name="hauth" :value="initSignatureResponse.loginHAuth" />
            </form>
        </template>
        <template #modal-footer="{ cancel }">
            <IdeoButton :variant="action.buttonVariant" @click="submit">
                <i v-if="action.buttonIcon" class="me-2" :class="action.buttonIcon"></i>
                <span>{{ action.buttonName }} </span>
            </IdeoButton>
            <IdeoButton variant="secondary" @click="cancel()">
                {{ $t('[[[Anuluj]]]') }}
            </IdeoButton>
        </template>
    </IdeoModal>
</template>
